class translateService {
    constructor($rootScope, $http, $q) {
        'ngInject';

        this.$http = $http;
        this.deferred = $q.defer();
        this.promise = this.deferred.promise;
        this.$rootScope = $rootScope;

        this.setCurrentLang(
            document.getElementsByTagName('html')[0].attributes.lang.value || 'pl'
        );
    }

    getCurrentTranslations() {
        console.log(`translateService::getCurrentTranslations -> ${this.currentLang}: load translations from JSON file!`)

        return this.$http.get(
            `/assets/frontend/js/i18n/${this.currentLang}.json?v=202007270`
        );
    }

    setCurrentLang(lang) {
        this.translations = {};
        this.currentLang = lang;

        setTimeout(() => {
            if(typeof(translations) != 'undefined') {
                this.translations = translations;
                this.deferred.resolve(true);
                this.$rootScope.$apply();
            } else {
                this.getCurrentTranslations().then(
                    (response) => {
                        this.translations = response.data;
                        this.deferred.resolve(true);

                        translations = this.translations;
                    },
                    () => {
                        console.log(`translateService::getCurrentTranslations -> ${this.currentLang}: can't load translations JSON file!`)
                    }
                )
            }
        }, 50);
    }

    translate(slug, values) {
        if (typeof slug !== 'string') {
            return undefined;
        }

        const parts = slug.split('.');

        let translate = this.translations;

        for (const part of parts) {
            if (typeof translate[part] === 'undefined') {
                return slug;
            }

            translate = translate[part];
        }

        if (values && typeof values === 'object') {
            const keys = Object.keys(values).map(k => `{${k}}`);
            const matches = Object.values(values);

            if (!keys || !matches || keys.length < 1 || keys.length != matches.length) {
                return translate;
            }

            for (let i = 0; i < keys.length; i++) {
                translate = translate.replace(keys[i], matches[i]);
            }
        }

        return translate;
    }

    t(slug, values) {
        return this.translate(slug, values);
    }
}

export default translateService;
